import { render, staticRenderFns } from "./DetailDiaComponent.vue?vue&type=template&id=2ad18b1e"
import script from "./DetailDiaComponent.vue?vue&type=script&lang=js"
export * from "./DetailDiaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports